exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-data-js": () => import("./../../../src/pages/data.js" /* webpackChunkName: "component---src-pages-data-js" */),
  "component---src-pages-donar-js": () => import("./../../../src/pages/donar.js" /* webpackChunkName: "component---src-pages-donar-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-jugar-js": () => import("./../../../src/pages/jugar.js" /* webpackChunkName: "component---src-pages-jugar-js" */),
  "component---src-pages-swap-js": () => import("./../../../src/pages/swap.js" /* webpackChunkName: "component---src-pages-swap-js" */)
}

